module.exports = __webpack_public_path__ + "static/media/disney_d_logo.a40e3f53.png";